export { default as ModalContent } from './modal-content';
export { default as ModalFooter } from './modal-footer';
export { default as ModalHeader } from './modal-header';
export { default as Modal } from './modal';

export type { ModalProps } from './modal';
